/**
 * Many small sparkles for platform theme (login, launcher, platform admin).
 * Positions are randomized; each sparkle has a visible twinkle animation.
 */
import { useState } from 'react';

const SPARKLE_COLORS = [
  'rgba(255, 255, 255, 0.95)',
  'color-mix(in srgb, var(--accent) 9%, transparent)',
  'rgba(255, 46, 151, 0.85)',
  'rgba(255, 184, 0, 0.9)',
  'rgba(255, 255, 255, 0.8)',
] as const;

const N_SPARKLES = 80;

interface SparkleItem {
  top: string;
  left: string;
  size: number;
  colorIdx: number;
  duration: number;
  delay: number;
}

function generateSparkleConfig(): SparkleItem[] {
  const config: SparkleItem[] = [];
  for (let i = 0; i < N_SPARKLES; i++) {
    config.push({
      top: `${Math.random() * 100}%`,
      left: `${Math.random() * 100}%`,
      size: 4 + Math.floor(Math.random() * 11),
      colorIdx: Math.floor(Math.random() * SPARKLE_COLORS.length),
      duration: 1.4 + Math.random() * 1.8,
      delay: Math.random() * 3,
    });
  }
  return config;
}

export function PlatformSparkles() {
  const [config] = useState<SparkleItem[]>(() => generateSparkleConfig());

  return (
    <>
      {config.map((cfg, i) => (
        <div
          key={i}
          className="platform-sparkle"
          style={{
            ['--sparkle-size' as string]: `${cfg.size}px`,
            ['--sparkle-top' as string]: cfg.top,
            ['--sparkle-left' as string]: cfg.left,
            ['--sparkle-color' as string]: SPARKLE_COLORS[cfg.colorIdx],
            ['--sparkle-duration' as string]: `${cfg.duration.toFixed(2)}s`,
            ['--sparkle-delay' as string]: `${cfg.delay.toFixed(2)}s`,
          }}
          aria-hidden
        />
      ))}
    </>
  );
}
